
import Dialog from '../Dialog/EDDialog';
import EDTypography from '../Typography/EDTypography';

interface IProps {
  title: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmCaption: string;
}

/**
 * En varning/konfirmeringsdialog som visas när användaren försöker ta bort en analys.
 */
const EDConfirmationDialog: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <Dialog
    title={props.title}
    open={props.open}
    onClose={props.onClose}
    footerActions={[
      { label: 'Avbryt', onClick: props.onClose },
      { label: props.confirmCaption, onClick: props.onConfirm },
    ]}
  >
    <EDTypography>{props.children}</EDTypography>
  </Dialog>
);

export default EDConfirmationDialog;
